// src/components/rbac/RoleManager.jsx
import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { GET_ROLES, ADD_ROLE, DELETE_ROLE } from "../../graphql/rbac";

export default function RoleManager() {
  const { data, loading, refetch } = useQuery(GET_ROLES, { fetchPolicy: "network-only" });
  const [addRole] = useMutation(ADD_ROLE);
  const [deleteRole] = useMutation(DELETE_ROLE);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const roles = data?.getRoles?.roles || [];

  const handleAdd = async () => {
    if (!name.trim()) return alert("Name required");
    const res = await addRole({ variables: { data: { name: name.trim(), description } } });
    if (res?.data?.addRole?.status === "SUCCESS") {
      setName("");
      setDescription("");
      refetch();
    } else {
      alert(res?.data?.addRole?.message || "Failed");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete role?")) return;
    const res = await deleteRole({ variables: { data: { id } } });
    if (res?.data?.deleteRole?.status === "SUCCESS") {
      refetch();
    } else {
      alert(res?.data?.deleteRole?.message || "Failed");
    }
  };

  return (
    <div className="text-white">
      <div className="grid grid-cols-3 gap-4 mb-6">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Role name" className="p-2 bg-[#0c0b0b] rounded" />
        <input value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Description" className="p-2 bg-[#0c0b0b] rounded" />
        <button onClick={handleAdd} className="bg-[#FBB034] px-4 py-2 rounded font-bold">Add Role</button>
      </div>

      {loading ? (
        <p className="text-gray-400">Loading roles...</p>
      ) : (
        <div>
          {roles.length === 0 ? (
            <p className="text-gray-400">No roles</p>
          ) : (
            <ul className="space-y-2">
              {roles.map((r) => (
                <li key={r.id} className="flex items-center justify-between bg-[#0c0b0b] p-3 rounded">
                  <div>
                    <div className="font-semibold text-[#FBB034]">{r.name}</div>
                    <div className="text-sm text-gray-300">{r.description}</div>
                  </div>
                  <button onClick={() => handleDelete(r.id)} className="text-red-500 px-3 py-1 rounded border border-red-500">Delete</button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
